import React from 'react';
import { Box, Typography } from '../../ui/core';

/**
 * Catches render/lifecycle errors in its subtree and shows a fallback
 * instead of letting the error unmount the whole app. Without a boundary,
 * a single throw (e.g. the Google Maps Polyline `setAt` crash) tears the
 * React tree down to the root and leaves an orphaned modal backdrop — the
 * "black screen". The boundary contains the blast radius to its subtree.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`ErrorBoundary${this.props.label ? ` [${this.props.label}]` : ''} caught:`, error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }
      return (
        <Box sx={{ padding: '16px 0' }}>
          <Typography variant="body2" color="text.secondary">
            {this.props.message || 'Something went wrong loading this section.'}
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
